<template>
	<g id="iconDollar__kist">
		<path style="fill:#FAC176;" d="M26.322,46.239v-3.255c-0.078-0.067-0.164-0.12-0.238-0.194L14.458,30.97
		c-0.605-0.52,0.971,0.501,1.55,0.219l4.546,1.05l14,14H26.322z M35.414,46.239h10.908v-4.51c1.819-1.369,3-3.538,3-5.99
		c0-1.008-0.205-1.965-0.567-2.841L35.414,46.239z"/>

		<rect x="24.322" y="46.239" style="fill:#556080;" width="24" height="11"/>
		<path style="fill:#BDC3C7;" d="M40.322,57.239h-16v-11h9.426c3.631,0,6.574,2.943,6.574,6.574V57.239z"/>
		<circle style="fill:#556080;" cx="33.822" cy="51.739" r="2.5"/>
		<path style="fill:#FAC176;" d="M32.226,9.941c1.233-0.542,2.096-1.77,2.096-3.202c0-1.933-1.567-3.5-3.5-3.5
		c-1.433,0-2.661,0.863-3.202,2.096L32.226,9.941z"/>
		<path style="fill:#FAC176;" d="M37.226,14.941c1.233-0.542,2.096-1.77,2.096-3.202c0-1.933-1.567-3.5-3.5-3.5
		c-1.433,0-2.661,0.863-3.202,2.096L37.226,14.941z"/>
		<path style="fill:#FAC176;" d="M42.226,19.941c1.233-0.542,2.096-1.77,2.096-3.202c0-1.933-1.567-3.5-3.5-3.5
		c-1.433,0-2.661,0.863-3.202,2.096L42.226,19.941z"/>
		<path style="fill:#FAC176;" d="M47.226,24.941c1.233-0.542,2.096-1.77,2.096-3.202c0-1.933-1.567-3.5-3.5-3.5
		c-1.433,0-2.661,0.863-3.202,2.096L47.226,24.941z"/>
		<path style="fill:#FDD7AD;" d="M26.822,32.239h-10c-1.925,0-3.5-1.575-3.5-3.5v0c0-1.925,1.575-3.5,3.5-3.5h10
		c1.925,0,3.5,1.575,3.5,3.5v0C30.322,30.664,28.747,32.239,26.822,32.239z"/>
		<g  id="iconDollar__green">
			<path style="fill:#E8E8D3;" d="M22.255,0L5.285,16.971l9.192,9.192c0.623-0.567,1.441-0.923,2.345-0.923h10
		c1.925,0,3.5,1.575,3.5,3.5s-1.575,3.5-3.5,3.5h-6.269l14.43,14.43l16.971-16.971L22.255,0z"/>
		<path style="fill:#6D8C60;" d="M28.619,12.021c-0.391,0.391-1.023,0.391-1.414,0l-2.192-2.192c-1.623,1.078-3.895,1.078-5.516,0
l-4.384,4.385c1.101,1.665,1.101,3.85,0,5.515l2.192,2.192c0.391,0.391,0.391,1.023,0,1.414c-0.195,0.195-0.451,0.293-0.707,0.293
s-0.512-0.098-0.707-0.293l-3.535-3.535l0.707-0.707c1.169-1.17,1.169-3.073,0-4.243l-0.707-0.707l7.071-7.071l0.707,0.707
c1.133,1.133,3.108,1.133,4.243,0l0.707-0.707l3.536,3.536C29.01,10.998,29.01,11.63,28.619,12.021z M44.883,26.87l-3.535-3.535
c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l2.192,2.192c-1.101,1.665-1.101,3.85,0,5.515l-4.384,4.385
c-1.623-1.079-3.895-1.079-5.516,0l-2.192-2.192c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l3.536,3.536l0.707-0.707
c1.134-1.134,3.109-1.132,4.243,0l0.707,0.707l7.071-7.071l-0.707-0.707c-1.169-1.17-1.169-3.073,0-4.243L44.883,26.87z
 M47.004,28.991c-0.391-0.391-1.024-0.391-1.414,0c-0.391,0.391-0.391,1.024,0,1.414c0.391,0.391,1.024,0.391,1.414,0
C47.395,30.015,47.395,29.382,47.004,28.991z M34.276,40.305c-0.391,0.391-0.391,1.024,0,1.414s1.024,0.391,1.414,0
c0.391-0.391,0.391-1.024,0-1.414C35.3,39.915,34.667,39.915,34.276,40.305z M22.963,6.364c0.391-0.391,0.391-1.024,0-1.414
c-0.391-0.391-1.024-0.391-1.414,0c-0.391,0.391-0.391,1.024,0,1.414C21.939,6.754,22.572,6.754,22.963,6.364z M10.235,16.263
c-0.391,0.391-0.391,1.024,0,1.414c0.391,0.391,1.024,0.391,1.414,0c0.391-0.391,0.391-1.024,0-1.414
C11.258,15.873,10.625,15.873,10.235,16.263z"/>
		<path style="fill:#6D8C60;" d="M34.983,16.971c-3.515-3.515-9.213-3.515-12.728,0c-2.245,2.245-3.049,5.38-2.426,8.268h6.992
		c1.925,0,3.5,1.575,3.5,3.5c0,1.813-1.402,3.298-3.173,3.467c2.765,0.456,5.702-0.374,7.834-2.507
		C38.498,26.184,38.498,20.485,34.983,16.971z"/>
		</g>
	</g>
</template>

<script>
	import { TimelineMax } from 'gsap'

	export default {
		name: "iconDollar",
		data: function () {
			return {
				tl:undefined,
			}
		},
		mounted() {
			this.tl = new TimelineMax({repeat:-1});
			this.start();
		},
		methods: {
			start() {
				this.tl.set("#iconDollar__kist", {transformOrigin:"bottom", rotation:-1.5});
				this.tl.to("#iconDollar__kist", 1, {transformOrigin:"bottom", rotation:1});
				this.tl.to("#iconDollar__kist", 1, {transformOrigin:"bottom", rotation:-1.5});
			}
		}
	}
</script>

<style scoped>

</style>
